import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, filter, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Environment } from '../classes/environment';
import { MatDialog } from '@angular/material/dialog';
import { CalAndNewsFileInfo, MyFile } from '../classes/fileInfo';
import { InfoDialogComponent } from '@trivelope/triv-ui-tools-lib';


@Injectable( { providedIn: 'root' } )
export class CalAndNewsFileService {


	constructor(
        private httpClient: HttpClient,
		@Inject('environment') private environment: Environment,
		private matSnackBar: MatSnackBar,
		private matDialog: MatDialog
	) {}


	uploadCalendarFiles( eventId: string, myFiles: MyFile[] ): Observable<CalAndNewsFileInfo[] | null> {

		if( !eventId || !eventId.length ) return of(null);
		if( !myFiles || !myFiles.length ) return of(null);

		const formData = new FormData();
		formData.append( "veranstaltungId", eventId );

		for( const myFile of myFiles ) {
			formData.append( 'files', myFile.file, myFile.file.name );
		}

		const obs = this.httpClient.post<{ verarbeitet: boolean, dateien: CalAndNewsFileInfo[] }>(
			this.environment.backendUrl + 'event/files/upload',
			formData,
			{
				reportProgress: true,
				observe: 'events',
			}
		);

		return this.manageUploadAnswer( obs, myFiles );

	}

	uploadNewsFiles( newsId: string, myFiles: MyFile[] ): Observable<CalAndNewsFileInfo[] | null> {

		if( !newsId || !newsId.length ) return of(null);
		if( !myFiles || !myFiles.length ) return of(null);

		const formData = new FormData();
		formData.append( "nachrichtenId", newsId );

		for( const myFile of myFiles ) {
			formData.append( 'files', myFile.file, myFile.file.name );
		}

		const obs = this.httpClient.post<{ verarbeitet: boolean, dateien: CalAndNewsFileInfo[] }>(
			this.environment.backendUrl + 'nachrichten/files/upload',
			formData,
			{
				reportProgress: true,
				observe: 'events',
			}
		);

		return this.manageUploadAnswer( obs, myFiles );

	}

	private manageUploadAnswer( obs: Observable<HttpEvent<any>>, myFiles: MyFile[] ): Observable<CalAndNewsFileInfo[] | null> {

		let fileInfos: CalAndNewsFileInfo[] | null = null;

		return obs.pipe(
			map( event => {
				if( !event ) return 0;
				switch( event.type ) {
					case HttpEventType.Sent:
						// console.log( 'Request has been made!' );
						return 0;

					case HttpEventType.ResponseHeader:
						// console.log( 'Response header has been received!' );
						return 99;

					case HttpEventType.UploadProgress:

						if( !event.total ) return 0;
						let progress = Math.round( event.loaded / event.total * 100 );
						if( progress >= 99 ) progress = 99;
						// console.log( 'Upload in progress: ', progress );
						return progress;

					case HttpEventType.Response:

						console.log( '100% !!', event.body, "filesSaved?!" );
						if( event.body ) {
							if( !event.body.verarbeitet ) return -1;
							if( !event.body.dateien || !event.body.dateien.length ) return -1;
							fileInfos = event.body.dateien;
							return 100;
						}
						else {
							// console.log( "an error occurred during the file upload? no file id was received", event.body );
							return -1;
						}

					default:
						return 0;
				}
			}),
			catchError( err => {
				console.log( "an error occurred during the call", err );
				return of(-1);
			} ),
			tap( progress => {
				for( const myFile of myFiles ) myFile.percentageUploaded = progress;
			} ),
			filter( progress => (  ( progress == 100 ) || ( progress == -1 )  ) ),
			map( n => {

				if( n != 100 ) {
					this.matDialog.open( InfoDialogComponent, {
						data: { title: "Fehler", message: "Beim Hochladen der Datei ist ein Fehler aufgetreten" }
					});
					return null;
				}

				if( fileInfos !== null ) {
					for( let i=0; i < fileInfos.length; i++ ) {
						myFiles[i].id = fileInfos[i].dateiId;
					}
				}
				return fileInfos;
			} ),

		);

	}


	deleteUploadedFile( fileId: string ): Observable<boolean> {

		return this.httpClient.delete<{ verarbeitet: boolean }>(
			this.environment.backendUrl + 'file/delete?dateiId=' + fileId
		).pipe(

			map( answer => {
				if( !answer || !answer.verarbeitet ) return false;
				return true;
			}),
			catchError( err => {
				this.matSnackBar.open( 'Beim Löschen der Datei ist ein Fehler aufgetreten', 'Fehler' );
				return of(false);
			})

		);

	}

}
